// Description: Verification step of the verify email process
// Updated: 20/08/2025
// Author: Simon Franklin

// React
import React from 'react';

// Material UI Components
import { Box, Typography } from '@mui/material';
import OTP from './OTP'; 

const handleSupportClick = () => {
  window.open('https://bit.ly/zap123-suporte', '_blank', 'noopener');
}

// Render The Component
const VerificationStep = ({
  code,
  setCode,
  focusedIndex,
  setFocusedIndex,
  error,
  timeLeft,
  loading,
  handleSubmit,
  handleResendCode,
  email
}) => {
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
      }}
    >
      <Typography
        sx={{
          marginBottom: '100px',
          fontSize: { xs: '1rem', sm: '1.3rem' }
          
        }}
      >
        Insira o código de verificação enviado para o e-mail: {email}
      </Typography>

      <OTP
        separator={<span style={{ margin: '0 5px' }}>-</span>}
        length={6}
        value={code}
        onChange={setCode}
        onComplete={(value) => setCode(value)}
        focusedIndex={focusedIndex}
        setFocusedIndex={setFocusedIndex}
      />

      {error && (
        <Typography color="error" sx={{ marginTop: '10px' }}>
          {error}
        </Typography>
      )}

      <Typography sx={{ marginTop: '3rem', marginBottom: '1.5rem', fontSize: '16px' }}>
        {timeLeft === 0 && !loading ? (
          <span
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={handleResendCode}
          >
            Reenviar código
          </span>
        ) : loading ? (
          <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>
            Aguarde...
          </span>
        ) : (
          <span>Reenviar código em {timeLeft}s</span>
        )}
      </Typography>

      <Typography variant="caption" sx={{ color: 'text.secondary', maxWidth: '400px', marginTop: '1.5rem' }}>
        Você não recebeu o código? Verifique sua caixa de spam ou
      </Typography>

      <Typography variant="caption" sx={{ color: 'text.secondary', maxWidth: '400px', marginTop: '0rem', textDecoration: 'underline', cursor: 'pointer' }} onClick={handleSupportClick}>
        Entre em contato com nossa equipe de suporte
      </Typography>
    </Box>
  );
};

export default VerificationStep;
